// ============================================================
// Yeni duyuru formu (§13)
// ============================================================

import { closeModal } from "./studentModal.js";
import { esc } from "../lib/fmt.js";
import { B } from "../domain/context.js";
import { BUGUN } from "../config.js";
import { HEDEFLER, TURLER, aliciOgrenciler } from "../domain/announcements.js";
import { KANALLAR } from "../domain/notifications.js";
import { Duyuru } from "../repo/entities.js";
import { oturum } from "../domain/auth.js";
import { rerender } from "../lib/rerender.js";
import { state } from "../state.js";

export function openDuyuruFormu() {
  const t = B();

  document.getElementById("modalBox").innerHTML = `
    <div class="p-6">
      <div class="flex items-start gap-3">
        <div class="flex-1 min-w-0">
          <h2 class="font-display font-bold text-lg">Yeni Duyuru</h2>
          <p class="text-xs text-inksoft mt-0.5">${esc(t.name)}</p>
        </div>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="grid grid-cols-2 gap-3 mt-4">
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Tür</span>
          <select id="dyTur" class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
            ${Object.entries(TURLER).map(([id, x]) =>
              `<option value="${id}">${x.icon} ${esc(x.label)}</option>`).join("")}
          </select>
        </label>
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Kime</span>
          <select id="dyHedef" class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
            ${Object.entries(HEDEFLER).map(([id, x]) =>
              `<option value="${id}">${esc(x.label)}</option>`).join("")}
          </select>
        </label>
      </div>

      <label id="dySinifKutu" class="block mt-3 hidden">
        <span class="text-[11px] font-bold text-inksoft uppercase">Sınıf</span>
        <select id="dySinif" class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
          ${t.classes.map(c => `<option value="${c.id}">${esc(c.name)}</option>`).join("")}
        </select>
      </label>

      <label class="block mt-3">
        <span class="text-[11px] font-bold text-inksoft uppercase">Başlık</span>
        <input id="dyBaslik" type="text" placeholder="Kısa ve net"
          class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
      </label>

      <label class="block mt-3">
        <span class="text-[11px] font-bold text-inksoft uppercase">Metin</span>
        <textarea id="dyMetin" rows="4" placeholder="Velilere ulaşacak mesaj"
          class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white"></textarea>
      </label>

      <div id="dySecenekKutu" class="hidden mt-3">
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Seçenekler</span>
          <input id="dySecenekler" type="text" value="Katılıyor, Katılmıyor"
            class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
          <span class="text-[11px] text-inksoft">Virgülle ayırın</span>
        </label>
        <label class="block mt-3">
          <span class="text-[11px] font-bold text-inksoft uppercase">Son yanıt tarihi</span>
          <input id="dySon" type="date" class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
        </label>
      </div>

      <div class="mt-3">
        <span class="text-[11px] font-bold text-inksoft uppercase">Kanallar</span>
        <div class="flex items-center gap-1.5 mt-1 flex-wrap">
          ${Object.entries(KANALLAR).filter(([k]) => t.notificationChannels?.[k]).map(([k, x]) => `
            <label class="inline-flex items-center gap-1.5 rounded-lg border border-line bg-white px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer">
              <input type="checkbox" data-dykanal="${k}" ${k === "uygulama" ? "checked disabled" : ""} class="w-3.5 h-3.5 accent-teal">
              ${x.icon} ${esc(x.label)}
            </label>`).join("")}
        </div>
      </div>

      <div id="dyOnizleme" class="rounded-xl bg-paper p-3 mt-3 text-[11px] text-inksoft"></div>

      <div class="flex items-center gap-2 mt-4">
        <button id="dyGonder" class="rounded-xl bg-ink text-white text-sm font-semibold px-4 py-2 hover:bg-inksoft disabled:opacity-40" disabled>Gönder</button>
        <button id="dyVazgec" class="rounded-xl border border-line bg-white text-sm font-semibold px-4 py-2">Vazgeç</button>
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;
  document.getElementById("dyVazgec").onclick = closeModal;

  const el = id => document.getElementById(id);

  const tazele = () => {
    const tur = el("dyTur").value;
    const hedef = el("dyHedef").value;
    el("dySinifKutu").classList.toggle("hidden", hedef !== "sinif");
    el("dySecenekKutu").classList.toggle("hidden", !TURLER[tur].onayIster && !TURLER[tur].anket);

    const alicilar = aliciOgrenciler(
      { hedef, hedefParam: el("dySinif")?.value }, state.branchId);
    el("dyOnizleme").textContent =
      `${alicilar.length} öğrencinin velisine ulaşacak.`;

    el("dyGonder").disabled = !el("dyBaslik").value.trim() || !el("dyMetin").value.trim();
  };

  ["dyTur", "dyHedef", "dySinif", "dyBaslik", "dyMetin"].forEach(id => {
    const e = el(id);
    if (e) { e.oninput = tazele; e.onchange = tazele; }
  });
  tazele();

  el("dyGonder").onclick = () => {
    const tur = el("dyTur").value;
    const hedef = el("dyHedef").value;
    const anketli = TURLER[tur].onayIster || TURLER[tur].anket;

    Duyuru.olustur(state.branchId, {
      id: `duy-${Date.now().toString(36)}`,
      tur,
      baslik: el("dyBaslik").value.trim(),
      metin: el("dyMetin").value.trim(),
      hedef,
      hedefParam: hedef === "sinif" ? el("dySinif").value : null,
      kanallar: ["uygulama", ...[...document.querySelectorAll("[data-dykanal]:checked")]
        .map(x => x.dataset.dykanal).filter(k => k !== "uygulama")],
      secenekler: anketli
        ? el("dySecenekler").value.split(",").map(x => x.trim()).filter(Boolean)
        : [],
      deadline: anketli ? (el("dySon").value || null) : null,
      createdAt: `${BUGUN}T${new Date().toTimeString().slice(0, 5)}`,
      createdBy: oturum()?.name ?? "—",
      eventId: null,
      responses: {},
    });

    closeModal();
    rerender();
  };
}
